import { useTranslation } from 'react-i18next';
import { mockShipments } from '@/mocks/dashboard';
import DashboardShipping from './components/DashboardShipping';

export default function ShippingPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.shipping.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Track shipments and deliveries</p>
      </div>
      <DashboardShipping shipments={mockShipments} />
    </div>
  );
}